export enum TableAction {
  ADD = 'add',
  EDIT = 'edit',
  DELETE = 'delete',
  ACTIVATED = 'activated',
  DEACTIVATED = 'deactivated'
}
